import { selectFeatureFlags } from '@common/features/configuration/selectors';
import { useAppSelector } from './redux';

export const useFeatureFlags = () => useAppSelector(selectFeatureFlags);
